import EntityType from '../constants/EntityType';
import SubEntityType from '../constants/SubEntityType';
import { ModelID } from '@/shared/models/BaseModel';

export default class MediaTargetData {
  constructor(
    readonly entityType: EntityType,
    readonly entityId?: ModelID | null,
    readonly subEntityType?: SubEntityType | null,
    readonly subEntityId?: ModelID | null,
  ) {}
}